import api from '@/api/fetch'
import { loadImage } from '@/utils/load-image'

import type { PrinterConfig, PrinterDriver } from '../types'

export default class AdyenPrinter implements PrinterDriver {
  private config: PrinterConfig

  constructor(config: PrinterConfig) {
    this.config = config
  }

  async printImage(imageDataUrl: string) {
    const img = await loadImage(imageDataUrl)
    const config = this.config

    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')!
    const parts = []
    const imgWidth = img.width
    const imgHeight = img.height
    canvas.width = imgWidth

    let currentHeight = 0
    const adderStep = 1000
    let currentAdder = adderStep
    while (currentHeight + currentAdder < imgHeight) {
      canvas.height = currentAdder
      ctx.drawImage(img, 0, currentHeight, imgWidth, currentAdder, 0, 0, imgWidth, currentAdder)
      const dataUrl = canvas.toDataURL('image/webp', 0.01)
      if (dataUrl.length > 90000) {
        parts.push(dataUrl)
        currentHeight += currentAdder
        currentAdder = adderStep
      } else {
        currentAdder += adderStep
      }
    }
    canvas.height = Math.min(currentAdder, imgHeight)
    ctx.drawImage(img, 0, currentHeight, imgWidth, currentAdder, 0, 0, imgWidth, currentAdder)
    parts.push(canvas.toDataURL('image/webp', 0.01))

    for (const part of parts) {
      const partData = part.split('base64,')[1]
      await api.post('pos/adyen/print', {
        imageBase64: partData,
        poiid: config.metadata.poiid
      })
    }
  }

  openCashDrawer() {
    // NO_OP
  }
}
